import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { PlaySolidIcon } from '@iris/react-icons/PlaySolidIcon';
import videoTriggerButtonStyles from './VideoTriggerButton.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

const VideoTriggerButton = forwardRef((_a, ref) => {
    var { size = "md", className, "aria-label": ariaLabel = "open video player", onClick } = _a, props = __rest(_a, ["size", "className", "aria-label", "onClick"]);
    const { button, icon, wrapper } = videoTriggerButtonStyles({
        size,
    });
    return (jsx("button", Object.assign({ ref: ref, "aria-label": ariaLabel, className: cn(button(), className), onClick: onClick }, props, { children: jsx("div", { className: wrapper(), children: jsx(PlaySolidIcon, { "aria-hidden": "true", className: icon() }) }) })));
});
VideoTriggerButton.displayName = "VideoTriggerButton";

export { VideoTriggerButton };
